import { render, staticRenderFns } from "./CardKeepScore.vue?vue&type=template&id=4b81c50a&scoped=true&"
import script from "./CardKeepScore.vue?vue&type=script&lang=js&"
export * from "./CardKeepScore.vue?vue&type=script&lang=js&"
import style0 from "./CardKeepScore.vue?vue&type=style&index=0&id=4b81c50a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81c50a",
  null
  
)

export default component.exports